'use client';

// Recovered from the IMAI v5 animation source; demo documents stay illustrative.
import * as React from 'react';
import { ShowcaseCopyContext, translateShowcaseNode } from '../translation';
import { ShowcaseIcon } from './scene-primitives';
import { BlurSwap, CompletionMark } from './playback-controls';
import { ProductionIcon } from './deliverable-previews';
import { T } from './workflow-facts';
import { ProductionBrandChip } from './deliverable-files';
import { J } from './sell-market-animation';
export function ProductionArtifact({
  icon: e,
  title: t,
  view: n,
  children: r,
  footer: i,
  className: a = '',
}) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  return (
    <div
      className={`sf flex min-w-0 flex-col overflow-hidden rounded-[14px] ${a}`}
    >
      <div
        className={
          'flex h-14 shrink-0 items-center gap-3 border-b border-[var(--line)] pr-2 pl-3 sm:pl-4'
        }
      >
        <span
          className={
            'bg-raised text-ink grid size-8 shrink-0 place-items-center rounded-lg shadow-[var(--shadow-minimal)]'
          }
        >
          <ShowcaseIcon name={e} className={'size-4'} />
        </span>
        <span
          className={
            'text-ink min-w-0 flex-1 truncate text-[15px] font-semibold tracking-[-0.01em]'
          }
        >
          {translateShowcaseNode(showcaseCopy, t)}
        </span>
        {translateShowcaseNode(
          showcaseCopy,
          n ? (
            <span
              className={
                'text-ink-3 hidden h-8 shrink-0 items-center gap-1 rounded-md px-2 text-[13px] sm:flex'
              }
            >
              <BlurSwap value={n} />
              <ShowcaseIcon name={'chevronDown'} className={'size-3.5'} />
            </span>
          ) : null
        )}
        <span
          aria-hidden={!0}
          className={
            'text-ink-3 grid size-8 shrink-0 place-items-center rounded-md'
          }
        >
          <ProductionIcon name={'download'} className={'size-4'} />
        </span>
      </div>
      <div className={'relative min-h-0 flex-1'}>
        {translateShowcaseNode(showcaseCopy, r)}
      </div>
      {translateShowcaseNode(
        showcaseCopy,
        i ? (
          <div
            className={
              'flex min-h-12 shrink-0 items-center gap-2 border-t border-[var(--line)] px-3 py-2 sm:px-4'
            }
          >
            {translateShowcaseNode(showcaseCopy, i)}
          </div>
        ) : null
      )}
    </div>
  );
}
export function TechpackTabs({ tabs: e, active: t }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  return (
    <div
      className={
        'pd-rail -mx-1 flex min-w-0 items-center gap-1.5 overflow-x-auto px-1'
      }
    >
      {translateShowcaseNode(
        showcaseCopy,
        e.map((e, n) => (
          <span
            key={e}
            className={`flex h-7 shrink-0 items-center rounded-full px-3 text-[12.5px] whitespace-nowrap transition-[background-color,color,box-shadow] duration-200 ${n === t ? 'bg-[var(--foreground)] text-[var(--background)]' : 'text-ink-3 shadow-[inset_0_0_0_1px_var(--border)]'}`}
          >
            {translateShowcaseNode(showcaseCopy, e)}
          </span>
        ))
      )}
    </div>
  );
}
export function ProductionIllustrativeBadge({ className: e = '' }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  return (
    <span
      className={`text-ink-4 inline-flex h-5 shrink-0 items-center rounded-full px-2 text-[11px] font-medium shadow-[inset_0_0_0_1px_var(--line)] ${e}`}
    >
      {translateShowcaseNode(showcaseCopy, 'Illustrative')}
    </span>
  );
}
export const Bf = {
  green: 'text-[var(--pd-green)] bg-[var(--pd-green-wash)]',
  amber: 'text-[var(--pd-amber)] bg-[var(--pd-amber-wash)]',
  red: 'text-[var(--pd-red)] bg-[var(--pd-red-wash)]',
  neutral: 'text-ink-3 bg-[var(--tint)]',
};
export function ProductionBadge({
  tone: e = 'neutral',
  children: t,
  className: n = '',
}) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  return (
    <span
      className={`inline-flex h-6 shrink-0 items-center gap-1 rounded-full px-2 text-[12px] font-medium whitespace-nowrap ${Bf[e]} ${n}`}
    >
      {translateShowcaseNode(showcaseCopy, t)}
    </span>
  );
}
export function ProductionProgress({ value: e, label: t, meta: n }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  return (
    <div className={'flex w-full min-w-0 flex-col gap-1.5'}>
      <div className={'flex items-center justify-between gap-3 text-[12.5px]'}>
        <span className={'text-ink-3'}>
          {translateShowcaseNode(showcaseCopy, t)}
        </span>
        <span className={'num text-ink-3'}>
          {translateShowcaseNode(showcaseCopy, n)}
        </span>
      </div>
      <span
        className={
          'block h-[3px] overflow-hidden rounded-full bg-[var(--tint-2)]'
        }
      >
        <span
          className={
            'block h-full origin-left rounded-full bg-[var(--foreground)] transition-transform duration-500 ease-[var(--ease)]'
          }
          style={{
            transform: `scaleX(${e})`,
          }}
        />
      </span>
    </div>
  );
}
export const Uf = {
  review: {
    kind: 'Review',
    meta: '6 products',
    units: 'checks ready',
  },
  lock: {
    kind: 'Document',
    meta: 'Freeze packet',
    units: 'sections ready',
  },
  techpack: {
    kind: 'Tech Pack',
    meta: `${T.components} components`,
    units: 'images done',
  },
  sourcing: {
    kind: 'Sheet',
    meta: '4 routes, 2 regions',
    units: 'checks ready',
  },
  rfq: {
    kind: 'Document',
    meta: '4 conflicts flagged',
    units: 'sections ready',
  },
  sample: {
    kind: 'Redline pack',
    meta: '4 redlines',
    units: 'redlines ready',
  },
  readiness: {
    kind: 'Review',
    meta: '6 gates',
    units: 'gates ready',
  },
  handoff: {
    kind: 'Folder',
    meta: '6 files',
    units: 'files ready',
  },
};
export const Wf = {
  techpack: T.componentImages.done,
};
export const Gf = {
  techpack: 'Draft for technical review',
};
export const Kf = {
  review: 6,
  lock: 3,
  techpack: T.componentImages.of,
  sourcing: 4,
  rfq: 4,
  sample: 4,
  readiness: 6,
  handoff: 6,
};
export function ProductionPrompt({ step: e }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  return (
    <div className={'flex justify-end'}>
      <p
        className={
          'text-ink max-w-[96%] rounded-[18px] bg-[var(--secondary)] px-4 py-2 text-[15px] leading-6 shadow-[var(--shadow-minimal)]'
        }
      >
        <span key={e.key} className={'ref-enter'}>
          <span
            className={'ref ref-violet'}
            style={{
              whiteSpace: 'normal',
            }}
          >
            <ShowcaseIcon name={e.icon} className={'ref-icon'} />
            {translateShowcaseNode(showcaseCopy, e.workflow)}
          </span>
          {translateShowcaseNode(showcaseCopy, ' ')}
          <span className={'ref ref-amber'}>
            <ProductionBrandChip brand={e.brand} />
          </span>
          {translateShowcaseNode(showcaseCopy, ' ')}
          {translateShowcaseNode(showcaseCopy, e.ask)}
        </span>
      </p>
    </div>
  );
}
export function ProductionWorkingStatus({ step: e, t }) {
  let n = t >= e.ms;
  return (
    <div className={'text-ink-3 flex h-7 items-center gap-2 px-1 text-[14px]'}>
      <span key={`${e.key}-${String(n)}`} className={'grid'}>
        <CompletionMark done={n} className={'size-4'} />
      </span>
      <BlurSwap value={n ? 'Finished working' : 'Working'} />
      <ShowcaseIcon name={'chevronRight'} className={'size-3.5'} />
    </div>
  );
}
export function ProductionConversation({ step: e, t }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  let n = Uf[e.key],
    r = Kf[e.key],
    i = Wf[e.key] ?? r,
    a = Math.min(i, Math.floor((t / e.ms) * i + 0.001)),
    o = t >= e.ms;
  return (
    <div className={'flex min-w-0 flex-col gap-3'}>
      <ProductionPrompt step={e} />
      <ProductionWorkingStatus step={e} t={t} />
      <p
        {...J(t, 500)}
        className={'pd-in text-ink px-1 text-[15px] leading-[1.65] text-pretty'}
      >
        {translateShowcaseNode(showcaseCopy, e.does)}
      </p>
      <div {...J(t, 900)} className={'pd-pop sf rounded-[14px] p-4'}>
        <div className={'text-ink-3 flex items-center gap-2 text-[13px]'}>
          <ShowcaseIcon name={'link'} className={'size-3.5'} />
          <span>{translateShowcaseNode(showcaseCopy, n.kind)}</span>
          <ShowcaseIcon
            name={'arrowRight'}
            className={'ml-auto size-3.5 -rotate-45'}
          />
        </div>
        <p
          className={
            'text-ink mt-2.5 text-[17px] leading-6 font-semibold tracking-[-0.01em]'
          }
        >
          {translateShowcaseNode(showcaseCopy, e.title)}
        </p>
        <p className={'text-ink-3 mt-1.5 flex items-center gap-2 text-[13px]'}>
          <span className={'text-ink'}>
            <BlurSwap
              value={o ? (Gf[e.key] ?? 'Ready for review') : 'Drafting'}
            />
          </span>
          <span className={'num'}>
            {translateShowcaseNode(showcaseCopy, n.meta)}
          </span>
        </p>
        <div className={'mt-4'}>
          <ProductionProgress
            value={a / r}
            label={'Overall progress'}
            meta={`${a}/${r} ${n.units}`}
          />
        </div>
      </div>
    </div>
  );
}
export const Xf = [
  {
    name: 'tote-tech-pack-v3.pdf',
    kind: 'pdf',
    what: 'Tech pack',
    version: 'v3',
    size: '4.2 MB',
  },
  {
    name: 'tote-bom.sheet',
    kind: 'spreadsheet',
    what: 'Bill of materials',
    version: 'v3',
    size: '38 KB',
  },
  {
    name: 'tote-measurements.sheet',
    kind: 'spreadsheet',
    what: 'Specs and tolerances',
    version: 'v3',
    size: '22 KB',
  },
  {
    name: 'colorways.pdf',
    kind: 'pdf',
    what: 'Colorways',
    version: 'v2',
    size: '1.8 MB',
  },
  {
    name: 'proto-1-redlines.pdf',
    kind: 'pdf',
    what: 'Sample redlines',
    version: 'v1',
    size: '2.6 MB',
  },
  {
    name: 'approvals.md',
    kind: 'document',
    what: 'Approvals and conditions',
    version: 'v1',
    size: '6 KB',
  },
];
